<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
@if (pageLoading1 || pageLoading2 || pageLoading3) {
<div class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
}
@if (navbar.userAccess?.Follow_up_report=='Full' || navbar.userAccess?.Follow_up_report=='Readonly'){
<div class="row">
	<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
		<div class="card">
			<div class="card-header bg-theme mb-0">
				<h5 class="card-title text-white mb-0">
					Details
				</h5>
			</div>
			<div class="card-body pt-0">
				<form [formGroup]="moduleForm" (ngSubmit)="saveReport_A()" #modform="ngForm">
					<!-- <div class="row mb-2 mt-1">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							@if (navbar.userAccess?.Follow_up_report=='Full'){
							<button type="submit" class="btn btn-sm btn-success me-1"
								[disabled]="saveLoader || !modform.dirty">
								@if(saveLoader){
								<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
								}@else{
								<fa-icon [icon]="['fas', 'save']"></fa-icon>
								}
								Save
							</button>
							}
							<a type="button" class="btn btn-sm btn-secondary"
								[routerLink]="['/app/appt-details','no',uId,'empty']">
								Cancel
							</a>
						</div>
					</div> -->
					@if(followUpDetails){
					<div class="row mb-2">
						<div class="col">
							<div class="table-responsive">
								<table class="table table-bordered">
									<tbody>
										<tr>
											<th>Name</th>
											<td>
												{{followUpDetails.case_id?.candidate?.f_name}}
												{{followUpDetails.case_id?.candidate?.l_name}}
											</td>
										</tr>
										<tr>
											<th>Case Id</th>
											<td>
												{{followUpDetails.case_id?.case_id}}
											</td>
										</tr>
										<tr>
											<th>Rank</th>
											<td>
												{{followUpDetails.case_id?.rank?.rank || "___"}}
											</td>
										</tr>
										<tr>
											<th>DOB</th>
											<td>
												{{followUpDetails.case_id?.candidate?.dob || "___"}}
											</td>
										</tr>
										<tr>
											<th>Vessel</th>
											<td>
												{{followUpDetails.case_id?.vessel?.vessel_name || "___"}}
											</td>
										</tr>
										<tr>
											<th>Company</th>
											<td>
												{{followUpDetails.case_id?.company?.com_name || "___"}}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					}
					<div class="row mb-2">
						<div class="col-md-6">
							<div class="form-floating">
								<input [ngClass]="{'is-invalid':showError('report_no')}" placeholder=""
									formControlName="report_no" id="report_no" class="form-control" />
								<label for="report_no">
									Report No.*
								</label>
							</div>
							@if (showError('report_no')) {
							<p class="text-danger mb-0">
								@if (f.report_no.errors?.required) {
								Required
								}
								@if (f.report_no.errors?.pattern) {
								Invalid
								}
							</p>
							}
						</div>
						<div class="col-md-6">
							<div class="input-group">
								<div class="form-floating">
									<input class="form-control" [ngClass]="{'is-invalid':showError('next_review_date')}"
										placeholder="" formControlName="next_review_date" ngbDatepicker
										id="next_review_date" #next_review_date="ngbDatepicker" [minDate]="minDate"
										[container]="'body'" />
									<label for="next_review_date">Next Review Date</label>
								</div>
								<button class="btn btn-outline-secondary" (click)="next_review_date.toggle()"
									type="button">
									<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
								</button>
							</div>
							@if (showError('next_review_date')) {
							<p class="text-danger">
								@if(f.next_review_date.errors?.required){
								Required
								}
							</p>
							}
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-md-6">
							<div class="form-floating">
								<input [ngClass]="{'is-invalid':showError('expected_treatment_period')}" placeholder=""
									formControlName="expected_treatment_period" id="expected_treatment_period"
									class="form-control" />
								<label for="expected_treatment_period">
									Expected Treatment Period
								</label>
							</div>
							@if (showError('expected_treatment_period')) {
							<p class="text-danger mb-0">
								@if (f.expected_treatment_period.errors?.required) {
								Required
								}
							</p>
							}
						</div>
						<div class="col-md-6">
							<div class="form-floating">
								<input [ngClass]="{'is-invalid':showError('expected_treatment_cost')}" placeholder=""
									formControlName="expected_treatment_cost" id="expected_treatment_cost"
									class="form-control" />
								<label for="expected_treatment_cost">
									Expected Treatment Cost
								</label>
							</div>
							@if (showError('expected_treatment_cost')) {
							<p class="text-danger mb-0">
								@if (f.expected_treatment_cost.errors?.required) {
								Required
								}
							</p>
							}
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-md-12">
							<div class="form-floating">
								<input [ngClass]="{'is-invalid':showError('further_advice')}" placeholder=""
									formControlName="further_advice" id="further_advice" class="form-control" />
								<label for="further_advice">
									Further Advice
								</label>
							</div>
							@if (showError('further_advice')) {
							<p class="text-danger mb-0">
								@if (f.further_advice.errors?.required) {
								Required
								}
							</p>
							}
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-md-12">
							<div class="form-floating">
								<input [ngClass]="{'is-invalid':showError('fitness_status')}" placeholder=""
									formControlName="fitness_status" id="fitness_status" class="form-control" />
								<label for="fitness_status">
									Fitness Status
								</label>
							</div>
							@if (showError('fitness_status')) {
							<p class="text-danger mb-0">
								@if (f.fitness_status.errors?.required) {
								Required
								}
							</p>
							}
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-md-12">
							<ng-select [ngClass]="{'is-invalid':showError('previous_followups')}" [items]="prevFollList"
								bindValue="id" [clearable]="true" [multiple]="true" placeholder="Previous Follow-ups"
								formControlName="previous_followups" appearance="outline">
								<ng-template ng-label-tmp let-item="item">
									{{item.follow_up_date}}
									&nbsp;|&nbsp;
									{{item.visit_type?.name}}
									<span class="badge fw-bold text-dark"
										[ngClass]="getFollowUpStatusClass(item.follow_up_status?.id)">
										{{ item?.follow_up_status?.name }}
									</span>
								</ng-template>
								<ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
									{{item.follow_up_date}}
									&nbsp;|&nbsp;
									{{item.visit_type?.name}}
									<span class="badge fw-bold text-dark"
										[ngClass]="getFollowUpStatusClass(item.follow_up_status?.id)">
										{{ item?.follow_up_status?.name }}
									</span>
								</ng-template>
							</ng-select>
							@if(showError('previous_followups')){
							<p class="text-danger">
								@if(f.previous_followups.errors?.required){
								Required
								}
							</p>
							}
						</div>
					</div>
					<!-- <div class="row mb-2">
						<div class="col-md-12">
							<div class="form-floating">
								<input [ngClass]="{'is-invalid':showError('due_to')}" placeholder=""
									formControlName="due_to" id="due_to" class="form-control" />
								<label for="due_to">
									Due To
								</label>
							</div>
							@if (showError('due_to')) {
							<p class="text-danger mb-0">
								@if (f.due_to.errors?.required) {
								Required
								}
							</p>
							}
						</div>
					</div> -->
					<!-- <div class="row mb-2">
						<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
							<ng-select [ngClass]="{'is-invalid':showError('doctor_1_id')}" [items]="doctortList"
								bindLabel="name" bindValue="id" [clearable]="true" id="doctor_1_id"
								formControlName="doctor_1_id" placeholder="Doctor 1*" [appearance]="'outline'">
							</ng-select>
							@if(showError('doctor_1_id')){
							<p class="text-danger">
								@if(f.doctor_1_id.errors?.required){
								Required
								}
							</p>
							}
						</div>
						<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
							<ng-select [ngClass]="{'is-invalid':showError('doctor_2_id')}" [items]="doctortList"
								bindLabel="name" bindValue="id" [clearable]="true" id="doctor_2_id"
								formControlName="doctor_2_id" placeholder="Doctor 2*" [appearance]="'outline'">
							</ng-select>
							@if(showError('doctor_2_id')){
							<p class="text-danger">
								@if(f.doctor_2_id.errors?.required){
								Required
								}
							</p>
							}
						</div>
					</div> -->
					<div class="row mb-2">
						<div class="col-md-12">
							<table class="table table-bordered">
								<thead>
									<tr>
										<th>FAQ</th>
									</tr>
								</thead>
								<tbody>
									@for (creds of get_rows.controls; track $index) {
									<tr formArrayName="faq">
										<ng-container [formGroupName]="$index">
											<td>
												<p class="mb-1 fw-bold">
													{{$index + 1}}
													.&nbsp;
													{{creds.get('question')?.value}}
												</p>
												<div class="form-floating">
													<input [ngClass]="{'is-invalid':showError2($index,'answer')}"
														placeholder="" formControlName="answer" class="form-control" />
													<label>
														Answer
													</label>
												</div>
												@if(showError2($index,'answer')){
												<p class="text-danger mb-0">
													@if (creds.get('answer')?.errors?.required) {
													Required
													}
												</p>
												}
											</td>
										</ng-container>
									</tr>
									}
								</tbody>
							</table>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<mat-checkbox [color]="'primary'" formControlName="followup_report_sent"
								id="followup_report_sent">
								Report sent
							</mat-checkbox>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							@if (navbar.userAccess?.Follow_up_report=='Full'){
							<button type="submit" class="btn btn-sm btn-success me-1"
								[disabled]="saveLoader || !modform.dirty">
								@if (saveLoader) {
								<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
								}@else {
								<fa-icon [icon]="['fas', 'save']"></fa-icon>
								}
								Save
							</button>
							}
							<a type="button" class="btn btn-sm btn-secondary"
								[routerLink]="['/app/appt-details','no',uId,followId]">
								Cancel
							</a>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
	<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
		<div class="card">
			<div class="card-header bg-theme mb-0">
				<h5 class="card-title text-white mb-0">
					Report
				</h5>
			</div>
			<div class="card-body pt-0">
				@if (showReport) {
				<button class="btn btn-success btn-sm ms-3 float-end my-1" (click)="downloadReport()"
					matTooltip="Download" [disabled]="downloadLoader">
					@if (downloadLoader) {
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					}@else {
					<fa-icon [icon]="['fas','download']"></fa-icon>
					}
					Download
				</button>
				<iframe class="pdf-container" [src]="fileURL" type="application/pdf"></iframe>
				}
			</div>
		</div>
	</div>
</div>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}
<!-- <div class="modal fade" id="otpModalReport" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<form [formGroup]="otpForm" (ngSubmit)="showOTP?verifyOTP():getOTP()">
				<div class="modal-header">
					<h4 class="modal-title"><strong>OTP Verification</strong></h4>
					<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div class="row mb-2">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<h5>
								OTP Verification is required for editing notes
							</h5>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col">
							@if(!showOTP){
							<div class="form-floating">
								<input class="form-control" [ngClass]="{'is-invalid':showOTPFormError('reason')}"
									id="reason" formControlName="reason" placeholder="">
								<label for="reason">Please enter reason for editing*</label>
							</div>
							@if(showOTPFormError('reason')){
							<p class="text-danger">
								@if(f1.reason.errors?.required){
								Required
								}
								@if(f1.reason.errors?.incorrect){
								{{customErrorOTP.reason}}
								}
							</p>
							}
							}@else{
							<div class="form-floating">
								<input class="form-control" [ngClass]="{'is-invalid':showOTPFormError('otp')}" id="otp"
									formControlName="otp" placeholder="">
								<label for="otp">OTP*</label>
							</div>
							@if (showOTPFormError('otp')) {
							<p class="text-danger">
								@if (f1.otp.errors?.required) {
								Required
								}
								@if (f1.otp.errors?.incorrect) {
								{{customErrorOTP.otp}}
								}
							</p>
							}
							<p class="text-success">
								OTP sent to {{otpMailId}}
							</p>
							}
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="submit" class="btn btn-sm btn-success" [disabled]="otpFormLoader">
						@if (otpFormLoader) {
						<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
						}
						{{showOTP?"Verify OTP":"Send OTP"}}
					</button>
					<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</div> -->